import { factoryService, getJsonRequest, getFileRequest } from '@chilecompra/react-kit/requests'
import { REACT_APP_API_BEHAVIOR_INDICATOR_BASE_URL } from '../config/settings/environment'

const BEHAVIOR_INDICATOR_URL = `${REACT_APP_API_BEHAVIOR_INDICATOR_BASE_URL}/v1/comportamiento-compradores`

/**
 * Get behavior dimensions
 */
export const getDimensions = factoryService(() => {
  return getJsonRequest(`${BEHAVIOR_INDICATOR_URL}/dimensions`)
})

/**
 * Get average behavior indicator data
 */
export const getAverageBehaviorIndicator = factoryService(({ dni, year, month }) => {
  const queryParams = {
    tax: dni
  }

  if (year) {
    queryParams.year = year
  }

  if (month) {
    queryParams.month = month
  }

  const queryString = new URLSearchParams(queryParams).toString()

  return getJsonRequest(`${BEHAVIOR_INDICATOR_URL}/average?${queryString}`)
})

/**
 * Get behavior dimensions indicators
 */
export const getDimensionsIndicators = factoryService(({ dimensionId }) => {
  return getJsonRequest(`${BEHAVIOR_INDICATOR_URL}/dimensions/${dimensionId}/indicators`)
})

/**
 * Get behavior average dimensions data
 */
export const getAverageDimensions = factoryService(({ dni, year, month }) => {
  const queryParams = {
    month,
    tax: dni,
    year
  }

  const queryString = new URLSearchParams(queryParams).toString()

  return getJsonRequest(`${BEHAVIOR_INDICATOR_URL}/average/dimension?${queryString}`)
})

/**
 * Get behavior periods years
 */
export const getPeriodsYears = factoryService(() => {
  return getJsonRequest(`${BEHAVIOR_INDICATOR_URL}/periods/years`)
})

/**
 * Get behavior periods months
 */
export const getPeriodsMonths = factoryService(({ year }) => {
  const queryParams = {
    year
  }

  const queryString = new URLSearchParams(queryParams).toString()

  return getJsonRequest(`${BEHAVIOR_INDICATOR_URL}/periods/months?${queryString}`)
})

/**
 * Get behavior measurements indicators
 */
export const getMeasurementsIndicators = factoryService(({ dni, year, month, dimensionId }) => {
  const queryParams = {
    tax: dni,
    year,
    month,
    dimensionId
  }

  const queryString = new URLSearchParams(queryParams).toString()

  return getJsonRequest(`${BEHAVIOR_INDICATOR_URL}/measurements/indicators?${queryString}`)
})

/**
 * Generate PDF of behavior indicators
 */
export const generateBehaviorIndicatorsPdf = factoryService(({ dni }) => {
  return getFileRequest(`${BEHAVIOR_INDICATOR_URL}/generar-pdf?tax=${dni}`)
})
